// Native
import { useState } from "react"

// Components
import { AlertDialogBody, AlertDialogFooter, Button, ButtonGroup, useDisclosure, useToast } from "@chakra-ui/react"
import { Dialog } from "components"

// Config
import { API } from "config"

// Screens
import { Authenticate } from "screens"

export default function Delete({ data, onSuccess = () => {}, ...props }){

    const toast = useToast()
    const auth = useDisclosure()
    const [ loading, setLoading ] = useState(false)

    const onSubmit = async () => {
        setLoading(true)

        try{
            await API.delete(`/customers/${data?.consultant?.customer?.id}/bank_accounts/${data?.bank_account?.id}`)
            toast({ title: 'Conta bancária removida com sucesso!', status: 'info' })
            onSuccess()
            props.onClose()
        }catch(err){
            toast({ title: 'Não foi possível remover a conta agora.', description: err?.response?.data?.message, status: 'warning' })
        }

        setLoading(false)
    }

    return(
    <>
        <Dialog title="Remover conta bancária?" loading={loading} {...props}>
            <AlertDialogBody>
                Ao remover a conta bancária ou chave pix, esta ação não poderá mais ser desfeita. Tem certeza de que deseja continuar?
            </AlertDialogBody>
            <AlertDialogFooter>
                <ButtonGroup size="sm" isDisabled={loading}>
                    <Button isLoading={loading} children="Excluir Conta" onClick={auth.onOpen} />
                    <Button colorScheme="red" children="Cancelar" />
                </ButtonGroup>
            </AlertDialogFooter>
        </Dialog>

        {/* Screens */}
        <Authenticate onSuccess={onSubmit} {...auth} />
    </>
    )
}